"use client";

import { Heart, Leaf, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const promises = [{
    icon: Leaf,
    stickerBg: "bg-accent-cream",
    title: "Eco-conscious land management",
    description: "We prioritize sustainable clearing methods that enrich your soil and protect the local ecosystem."
  }, {
    icon: ShieldCheck,
    stickerBg: "bg-primary",
    title: "Licensed and insured experts",
    description: "Our team is fully certified, safety-trained, and equipped to handle your property with professional care."
  }, {
    icon: Heart,
    stickerBg: "bg-background",
    title: "Customer-first service",
    description: "We listen to your vision and work transparently to ensure your land is transformed exactly as you imagined."
  }];
  return;
}